/*eslint-disable*/
import React, { useEffect, useState, useContext, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import {
  Row,
  Col,
  CardBody,
  Card,
  CardHeader,
  CardFooter,
  CardTitle,
  Container,
} from "reactstrap";
import { Button } from "@material-ui/core";
import { FirebaseContext } from "common";

import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { features, language,STYLES } from "config";

const BranchInformation = () => {
  const { api } = useContext(FirebaseContext);
  const { get_Branch_By_Name } = api;

  const navigate = useNavigate();
  const location = useLocation();
  const branch = location.state; // Retrieve passed branch data
  const dispatch = useDispatch();

  const auth = useSelector((state) => state.auth);
  const brokers = useSelector((state) => state.brokers.users);
  const listings = useSelector((state) => state.ListingData.listingsByBranch);
  const activeListingsByBranch = useSelector(
    (state) => state.ListingData.activeListingsByBranch
  );
  const inactiveListingsByBranch = useSelector(
    (state) => state.ListingData.inactiveListingsByBranch
  );
  const enquiryManagementReducer = useSelector((state) => state.enquirydata);
  const branchEnquiries = useSelector(
    (state) => state.enquirydata.branchEnquirries
  );
  const activeBranchEnquiries = useSelector(
    (state) => state.enquirydata.activeBranchEnquiries
  );
  const inactiveBranchEnquiries = useSelector(
    (state) => state.enquirydata.inactiveBranchEnquiries
  );

  const [branches, setBranches] = useState(location.state);
  const [brokerList, setBrokerList] = useState([]);

  useEffect(() => {
    let arr = [];
    if (brokers) {
      console.log("branches:", branches.BranchName); // Log brokers to verify data
      for (let index = 0; index < brokers.length; index++) {
        const element = brokers[index];

        // Populate the list with all brokers, remove brokerHomeOffice filter
        if (element.brokerHomeOffice === branches.BranchName) {
          arr.push(element);
        }
      }

      setBrokerList(
        arr.sort((a, b) => a?.username?.localeCompare(b?.username))
      );
    }
  }, [brokers]);

  if (!branch) {
    return (
      <div>
        <h1>No Branch Selected</h1>
        <Button color="secondary" onClick={() => navigate(-1)}>
          Go Back
        </Button>
      </div>
    );
  }

  return (
    <>
      <Row>
        <Card
          style={{
            backgroundColor:STYLES.PRIMARY_APP_CLR,
            width: "100%",
            height: "20%",
          }}
        >
          <CardHeader>
            <CardTitle tag="h4" style={{ color: "white" }}>
              Branch Information
            </CardTitle>
          </CardHeader>
          <CardBody>
            <Container>
              {!branch ? (
                <>
                  <h1>No Branch Selected</h1>
                  <Button color="secondary" onClick={() => navigate(-1)}>
                    Go Back
                  </Button>
                </>
              ) : (
                <>
                  <h1>{branch.BranchName} Details</h1>
                  <Row>
                    <Col md="8">
                      <Card
                        style={{
                          minWidth: "275px",
                          border: "none",
                          borderRadius: 20,
                          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                        }}
                      >
                        <CardHeader
                          style={{
                            backgroundColor: "#f8f9fa",
                            borderBottom:STYLES.PRIMARY_APP_CLR,
                          }}
                        >
                          <CardTitle
                            tag="h4"
                            style={{ color: STYLES.TERTIARY_APP_CLR, fontWeight: "bold" }}
                          >
                            {branch.BranchName} Branch Details
                          </CardTitle>
                        </CardHeader>
                        <CardBody style={{ padding: "20px" }}>
                          <Row>
                            <Col md="6">
                              <p style={{ fontWeight: "600" }}>
                                <strong>Manager:</strong> {branch.manager}
                              </p>
                            </Col>
                            <Col md="6">
                              <p style={{ fontWeight: "600" }}>
                                <strong>Address:</strong> {branch.address}
                              </p>
                            </Col>
                          </Row>
                          <Row>
                            <Col md="6">
                              <p style={{ fontWeight: "600" }}>
                                <strong>Contact Info:</strong>{" "}
                                {branch.contactInfo}
                              </p>
                            </Col>
                            <Col md="6">
                              <p style={{ fontWeight: "600" }}>
                                <strong>Province:</strong> {branch.Province}
                              </p>
                            </Col>
                          </Row>
                          <Row>
                            <Col md="6">
                              <p style={{ fontWeight: "600" }}>
                                <strong>Date:</strong>{" "}
                                {moment(branch.createdAt).format(
                                  "MMMM Do YYYY"
                                )}
                              </p>
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                  <Button color="secondary" onClick={() => navigate(-1)}>
                    Back to Branch List
                  </Button>
                </>
              )}
            </Container>
          </CardBody>
        </Card>

        <GridItem xs={12} sm={12} md={12} lg={12}>
          <GridContainer spacing={1}>
            <GridItem xs={6}>
              <Card
                className="card-chart"
                style={{
                  minWidth: "275px",
                  border: "3px solid",
                  borderColor:STYLES.PRIMARY_APP_CLR,
                  borderRadius: 30,
                }}
              >
                <CardHeader>
                  <CardTitle
                    tag="h2"
                    style={{
                      fontSize: 30,
                      fontWeight: "1000",
                      margin: "10px 0 0 1px",
                      color: STYLES.TERTIARY_APP_CLR,
                    }}
                  >
                    BROKERS
                  </CardTitle>
                </CardHeader>
                <CardBody>
                  {/* Displaying example statistics - replace with actual data as needed */}
                  <Row mb="12">
                    <Col md="12">
                      <span style={{ fontSize: 18, margin: 5 }}>
                        Total Branch Brokers:
                      </span>{" "}
                      {brokerList.length}
                    </Col>
                    <hr />
                    {brokerList.map((broker) => {
                      return (
                        <>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-evenly",
                              alignItems: "center",
                              margin: 5,
                            }}
                          >
                            <div>
                              <Button
                                color="primary"
                                onClick={() => {


                                  if (auth.info.profile.adminHomeOffice === branch.BranchName) {
                                    navigate("/BrokerProfile", { state: broker })
                                  }
                                  else {
                                    alert("You do not have permission to view this content")
                                  }

                                }


                                }
                              >
                                Broker Profile
                              </Button>
                            </div>

                            <div>
                              {" "}
                              <span>
                                {" "}
                                {`${broker.firstName} ${broker.lastName}`}{" "}
                              </span>
                            </div>
                          </div>
                          <hr />
                        </>
                      );
                    })}

                    {/* Add more statistics as needed */}
                  </Row>
                </CardBody>
              </Card>
            </GridItem>

            <GridItem xs={6}>
              <Card
                className="card-chart"
                style={{
                  minWidth: "275px",
                  border: "3px solid",
                  borderColor:STYLES.PRIMARY_APP_CLR,
                  borderRadius: 30,
                }}
              >
                <CardHeader>
                  <CardTitle
                    tag="h2"
                    style={{
                      fontSize: 30,
                      fontWeight: "1000",
                      margin: "10px 0 0 1px",
                      color: STYLES.TERTIARY_APP_CLR,
                    }}
                  >
                    LISTINGS
                  </CardTitle>
                </CardHeader>
                <CardBody>
                  {/* Displaying example statistics - replace with actual data as needed */}
                  <Row mb="12">
                    <Col md="12">
                      <span style={{ fontSize: 18 }}>Total Listings:</span>{" "}
                      {activeListingsByBranch.length +
                        inactiveListingsByBranch.length}
                    </Col>
                    {/* Add more statistics as needed */}
                  </Row>
                </CardBody>
                <CardFooter>
                  <Button
                    color="primary"
                    onClick={() => {


                      if (auth.info.profile.adminHomeOffice === branch.BranchName) {
                        navigate("/stock", {
                          state: activeListingsByBranch,
                        });
                      }
                      else {
                        alert("You do not have permission to view this content")
                      }

                    }}
                  >
                    View active listings: {activeListingsByBranch.length}
                  </Button>
                  <Button
                    color="primary"
                    onClick={() => {
                      if (auth.info.profile.adminHomeOffice === branch.BranchName) {
                        navigate("/stock", {
                          state: inactiveListingsByBranch,
                        });
                      }
                      else {
                        alert("You do not have permission to view this content")
                      }


                    }}
                  >
                    View inactive listings: {inactiveListingsByBranch.length}
                  </Button>
                </CardFooter>
              </Card>

              <Card
                className="card-chart"
                style={{
                  minWidth: "275px",
                  border: "3px solid",
                  borderColor:STYLES.PRIMARY_APP_CLR,
                  borderRadius: 30,
                }}
              >
                <CardHeader>
                  <CardTitle
                    tag="h2"
                    style={{
                      fontSize: 30,
                      fontWeight: "1000",
                      margin: "10px 0 0 1px",
                      color: STYLES.TERTIARY_APP_CLR,
                    }}
                  >
                    AREAS
                  </CardTitle>
                </CardHeader>
                <CardBody>
                  {/* Displaying example statistics - replace with actual data as needed */}
                  <Row mb="12">
                    <Col md="12">
                      <span style={{ fontSize: 18 }}>Total Areas:</span>{" "}
                      {branches.length}
                    </Col>
                    {/* Add more statistics as needed */}
                  </Row>
                </CardBody>
                <CardFooter>
                  <Button color="primary">Stats</Button>
                </CardFooter>
              </Card>

              <Card
                className="card-chart"
                style={{
                  minWidth: "275px",
                  border: "3px solid",
                  borderColor:STYLES.PRIMARY_APP_CLR,
                  borderRadius: 30,
                }}
              >
                <CardHeader>
                  <CardTitle
                    tag="h2"
                    style={{
                      fontSize: 30,
                      fontWeight: "1000",
                      margin: "10px 0 0 1px",
                      color: STYLES.TERTIARY_APP_CLR,
                    }}
                  >
                    ENQUIRIES
                  </CardTitle>
                </CardHeader>
                <CardBody>
                  {/* Displaying example statistics - replace with actual data as needed */}
                  <Row mb="12">
                    <Col md="12">
                      <span style={{ fontSize: 18 }}>
                        Total Branch Enquiries:
                      </span>{" "}
                      {activeBranchEnquiries.length +
                        inactiveBranchEnquiries.length}
                    </Col>
                    {/* Add more statistics as needed */}
                  </Row>
                </CardBody>
                <CardFooter>
                  <Button
                    color="primary"
                    onClick={() => {


                      if (auth.info.profile.adminHomeOffice === branch.BranchName) {
                        navigate("/enquiries", {
                          state: activeBranchEnquiries,
                        });
                      }
                      else {
                        alert("You do not have permission to view this content")
                      }

                    }}
                  >
                    View active enquiries: {activeBranchEnquiries.length}
                  </Button>
                  <Button
                    color="primary"
                    onClick={() => {
                      if (auth.info.profile.adminHomeOffice === branch.BranchName) {
                        navigate("/enquiries", {
                          state: inactiveBranchEnquiries,
                        });
                      }
                      else {
                        alert("You do not have permission to view this content")
                      }
                    }}
                  >
                    View inactive enquiries: {inactiveBranchEnquiries.length}
                  </Button>
                </CardFooter>
              </Card>
            </GridItem>
          </GridContainer>
        </GridItem>
      </Row>
    </>
  );
};

export default BranchInformation;
